<span class="patient-status-badge" [ngClass]="'patient-status-badge--' + variant">{{ label }}</span>
